import { ReservationFormData, Stop } from "../types";
import { MAX_STOPS } from "../constants";

/**
 * Helpers CRUD pour les étapes intermédiaires (mode multi-trajets).
 * Extrait tel quel de `useReservationForm` (aucun changement de comportement).
 */
export const useStops = (
  formData: ReservationFormData,
  setFormData: React.Dispatch<React.SetStateAction<ReservationFormData>>,
) => {
  const addStop = () => {
    if (formData.stops.length >= MAX_STOPS) return;

    const newStop: Stop = {
      id: crypto.randomUUID(),
      address: "",
      waitingTime: 0,
    };

    setFormData((prev) => ({
      ...prev,
      stops: [...prev.stops, newStop],
    }));
  };

  const removeStop = (stopId: string) => {
    setFormData((prev) => ({
      ...prev,
      stops: prev.stops.filter((stop) => stop.id !== stopId),
    }));
  };

  const updateStop = (stopId: string, address: string) => {
    setFormData((prev) => ({
      ...prev,
      stops: prev.stops.map((stop) =>
        stop.id === stopId ? { ...stop, address } : stop,
      ),
    }));
  };

  const updateStopWaitingTime = (stopId: string, waitingTime: number) => {
    setFormData((prev) => ({
      ...prev,
      stops: prev.stops.map((stop) =>
        stop.id === stopId ? { ...stop, waitingTime } : stop,
      ),
    }));
  };

  return { addStop, removeStop, updateStop, updateStopWaitingTime };
};
